import { FAILED_UPLOADS } from './index';
import { CLEAR_SELECTED_FILES } from '../addPhotos';

const initialState = [];
export const RESET_FAILED_UPLOADS = 'FAILED_UPLOADS/RESET_FAILED_UPLOADS';

const failedImageUploads = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_SELECTED_FILES:
    case RESET_FAILED_UPLOADS:
      return [];
    case FAILED_UPLOADS:
      return state.concat([{ ...action.image }]);
    default:
      return state;
  }
};

export default failedImageUploads;
